import React from 'react'
import { isKambiSportsSelection } from '@mobi/betslip/helpers/typeGuards'
import { QuickbetState, state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { observeImmutable } from '@core/Components/HOCs/observe'
import { BetInfoHeader, KambiSportsHeader, MultiHeader } from './Components'

export const BetSelectionInfo: React.ComponentClass = observeImmutable(
  quickbetState$,
  ({ record }) => {
    const { selection, selectionDetails, selectionMultiLegs, bettingType } =
      record.toJS() as QuickbetState

    if (selectionMultiLegs && selectionMultiLegs.length > 0) {
      return <MultiHeader legs={selectionMultiLegs} />
    }

    if (!selection) {
      return null
    }

    if (bettingType === 'kambi-sports' && isKambiSportsSelection(selection)) {
      return <KambiSportsHeader selection={selection} />
    }

    return <BetInfoHeader selectionDetails={selectionDetails} />
  }
)
